import type { ReactElement } from 'react';

import { memo } from 'react';
import styled, { css } from 'styled-components';

import { S as RecommendationsStyles } from './styles';
import { shimmerAnimation } from '../common/styles';
import { media } from '../core/styles';
import { SkeletonTile } from '~/components/productList/listing/SkeletonTile';

const TILE_COUNT = 5;

const S = {
  Wrapper: RecommendationsStyles.RecommendationsWrapper,

  TitleBar: styled.div`
    ${({ theme }) => css`
      padding: ${theme.padding.md} ${theme.padding.sm};

      @media ${media(theme).greaterThan('sm')} {
        padding-inline: var(--recommendation-margin, 0);
      }
    `}
  `,

  TitleBarInner: styled.div`
    ${({ theme }) => css`
      height: ${theme.font.size[6]};
      width: 240px;
      background-color: ${({ theme }) => theme.colors.neutral[200]};
      border-radius: 2px;

      @media ${media(theme).greaterThan('sm')} {
        height: ${theme.font.size[7]};
        width: 300px;
      }

      ${shimmerAnimation};
    `}
  `,

  TilesRow: styled.div`
    ${({ theme }) => css`
      display: grid;
      overflow: hidden;
      gap: ${theme.size['1']};
      grid-template-columns: repeat(${TILE_COUNT}, 43%);

      --product-tile-details-height: 68px;

      @media ${media(theme).greaterThan('sm')} {
        grid-template-columns: repeat(${TILE_COUNT}, calc((300 / (3 * 3 + 1)) * 1%));
        padding-inline: var(--recommendation-margin, 0);

        --product-tile-details-height: 82px;
      }

      @media ${media(theme).greaterThan('lg')} {
        grid-template-columns: repeat(${TILE_COUNT}, calc((300 / (3 * 5 + 1)) * 1%));

        --product-tile-details-height: 89px;
      }
    `}
  `,
};

const RecommendationsCarouselSkeletonComponent = (): ReactElement => (
  <S.Wrapper data-testid="recommendations-skeleton">
    <S.TitleBar>
      <S.TitleBarInner />
    </S.TitleBar>
    <S.TilesRow>
      {Array.from({ length: TILE_COUNT }, (_, i) => (
        <SkeletonTile key={`skeleton-tile-${i}`} />
      ))}
    </S.TilesRow>
  </S.Wrapper>
);

export const RecommendationsCarouselSkeleton = memo(RecommendationsCarouselSkeletonComponent);
